import PropTypes from 'prop-types'
import styled from 'styled-components'

import { sortBasedOnDate } from 'helpers/alerts'

import AlertList from 'pages/shared/AlertList'
import CollapsiblePanel from 'components/CollapsiblePanel'
import { Panel } from 'components/Panel'

import { color } from 'styles/colors'

const propTypes = {
  alertDescriptions: PropTypes.arrayOf(PropTypes.shape)
}

const defaultProps = {
  alertDescriptions: []
}

const TriggeringAlertsPanel = ({ alertDescriptions }) => {
  return (
    <S.CollapsiblePanel
      caretHorizontalPosition="right"
      headerComponent={
        <Panel.Header>
          <Panel.Title>Triggering Alerts</Panel.Title>
        </Panel.Header>
      }
    >
      <AlertList alerts={sortBasedOnDate(alertDescriptions, 'triggeredAt')} />
    </S.CollapsiblePanel>
  )
}

TriggeringAlertsPanel.propTypes = propTypes
TriggeringAlertsPanel.defaultProps = defaultProps

export default TriggeringAlertsPanel

const S = {
  // TODO: refactor CollapsiblePanel so that nested css selectors aren't required to style it
  CollapsiblePanel: styled(CollapsiblePanel)`
    & > div:first-of-type {
      border-radius: 4px;
      background-color: ${color('devicePanelHeader')};
      color: ${color('devicePanelHeaderText')};

      & > i:first-of-type {
        color: ${color('devicePanelHeaderText')};
      }
    }

    & > div:last-of-type {
      padding: 0;
      border: solid 1px ${color('border')};
      border-top: none;
    }
  `
}
